import React from 'react';

export default function WelcomeScreen({ onBegin, savedProgress, onResume, onStartFresh }) {
  const formattedDate = savedProgress
    ? new Date(savedProgress.savedAt).toLocaleDateString('en-AU', {
        day: 'numeric', month: 'short', year: 'numeric',
      })
    : '';

  return (
    <div className="view on" data-testid="welcome-screen" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <h1 data-content="landing.title">AI Navigator</h1>
      <p className="desc" data-content="landing.subtitle">Discover your AI readiness in 15 minutes</p>
      <p className="dim" data-content="landing.description">
        Answer 54 questions across 12 dimensions to receive your personalised AI readiness report.
      </p>
      <p className="dim" data-content="landing.time_estimate" style={{ marginBottom: '24px' }}>
        About 15 minutes
      </p>

      <button
        className="btn btn-p"
        onClick={onBegin}
        data-testid="begin-assessment-btn"
        data-content="landing.cta_button"
      >
        Begin Assessment
      </button>

      <p className="disclaimer" data-content="landing.disclaimer">
        Your responses are confidential and used solely for generating your personalised AI readiness report.
      </p>

      {savedProgress && (
        <div className="c" style={{ marginTop: '24px', padding: '24px', textAlign: 'center' }}>
          <p className="dim">You have a saved assessment from {formattedDate}.</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '16px' }}>
            <button className="btn btn-p" onClick={onResume} data-testid="resume-btn">Resume</button>
            <button className="btn btn-s" onClick={onStartFresh} data-testid="start-fresh-btn">Start Fresh</button>
          </div>
        </div>
      )}
    </div>
  );
}
